module.exports = __webpack_public_path__ + "static/media/upload-icon.5b65aadb.svg";